var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tasks" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [{ title: "Tasks" }],
          select: true,
          "show-subjects": false,
        },
      }),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "head-bar" }, [
          !!_vm.batchOperationItems().length
            ? _c(
                "div",
                { staticClass: "batch-operation" },
                [
                  _c(
                    "a-input-group",
                    { attrs: { compact: "" } },
                    [
                      _c("a-button", { attrs: { value: "test" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "5px",
                            },
                          },
                          [
                            _c("a-checkbox", {
                              staticClass: "kanban-checkbox",
                              attrs: {
                                indeterminate: _vm.checkedAllTasks(),
                                checked: _vm.checkedAllTask,
                              },
                              on: { change: _vm.changeCheckedTasks },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-button", { attrs: { value: "test" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "5px",
                            },
                            on: {
                              click: function ($event) {
                                _vm.changeStageModal = true
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                staticStyle: { "font-size": "20px" },
                              },
                              [_vm._v("table_chart")]
                            ),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("task.changeStage")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("a-button", { attrs: { value: "xd" } }, [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "5px",
                            },
                            on: {
                              click: function ($event) {
                                _vm.deleteMultipleTasksModal = true
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "material-icons",
                                staticStyle: { "font-size": "20px" },
                              },
                              [_vm._v("delete")]
                            ),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("chatbotv2.delete")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.type,
                        callback: function ($$v) {
                          _vm.type = $$v
                        },
                        expression: "type",
                      },
                    },
                    _vm._l(_vm.options, function (option) {
                      return _c(
                        "a-radio-button",
                        { key: option.value, attrs: { value: option.value } },
                        [_vm._v(_vm._s(option.label))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                gap: "10px",
              },
            },
            [
              _c(
                "a-select",
                {
                  staticClass: "classic-new-select",
                  model: {
                    value: _vm.workflowId,
                    callback: function ($$v) {
                      _vm.workflowId = $$v
                    },
                    expression: "workflowId",
                  },
                },
                _vm._l(_vm.getWorkflows(), function (option) {
                  return _c(
                    "a-select-option",
                    { key: option.value, attrs: { value: option.value } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  option.label.length > 15
                                    ? option.label.substring(0, 15) + "..."
                                    : option.label
                                ) +
                                "\n                                "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "a-dropdown-button",
                {
                  staticClass: "menu-button",
                  on: { click: _vm.createTask },
                  scopedSlots: _vm._u([
                    {
                      key: "overlay",
                      fn: function () {
                        return [
                          _c(
                            "a-menu",
                            { on: { click: _vm.createWorkflow } },
                            [
                              _c("a-menu-item", { key: "1" }, [
                                _vm._v(" Workflow "),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("settings.create")) +
                      "\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    "user-select": "none",
                  },
                  on: { click: _vm.openTaskSettings },
                },
                [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("settings"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-dropdown",
                {
                  staticClass: "more-also",
                  attrs: { placement: "bottomRight" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "overlay",
                      fn: function () {
                        return [
                          _c(
                            "a-menu",
                            [
                              _c("a-menu-item", [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("message.exportToCSV")) +
                                    " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("div", { staticClass: "material-icons" }, [
                    _vm._v("more_vert"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "board" },
          [
            _vm.workflowId && _vm.type === "kanban"
              ? _c("TaskDraggable", { attrs: { workflowId: _vm.workflowId } })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "list" ? _c("KanbanList") : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.deleteMultipleTasksModal,
            icon: "exclamation-circle",
            title: "Delete Task",
          },
          on: {
            cancel: function ($event) {
              _vm.deleteMultipleTasksModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteMultipleTasksModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteMultipleTasks },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("task.deleteTaskCont")))])]
      ),
      _vm._v(" "),
      _vm.changeStageModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Change Stage",
                description: "1 selected candidate(s)",
                "ok-text": "Save",
              },
              on: {
                cancel: function ($event) {
                  _vm.changeStageModal = false
                },
                ok: _vm.changeTaskPipeline,
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-group-container" },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.selectedPipelineId,
                        callback: function ($$v) {
                          _vm.selectedPipelineId = $$v
                        },
                        expression: "selectedPipelineId",
                      },
                    },
                    _vm._l(_vm.defaultWorkflow.pipeline, function (pipeline) {
                      return _c(
                        "a-radio",
                        { key: pipeline._id, attrs: { value: pipeline._id } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(pipeline.name) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }